export default {
    user(state) {
        return state.user;
    },
    token(state) {
        return state.token;
    },
    inPage(state) {
        return state.inPage === 'true' || state.inPage === '1';
    },
    isLoggedIn(state) {
        return state.isLoggedIn;
    },
    startDate(state) {
        return state.startDate;
    },
    isFetchedStartDate(state) {
        return state.isFetchedStartDate;
    },
    history(state) {
        return state.history;
    },
};
